import React from 'react'
import '../Styles/products.css'
import camisa from '../Assets/moletom-raffa.webp'
import bone from '../Assets/bone-raffa.webp'
import garrafa from '../Assets/garrafa-raffa.webp'
import CardProdut from '../Components/CardProdut'


function Products() {
  return (
    <section id='product-section' className='flex-center flex-column flex__gap-50 padding-50'>
        <h1 className='title-main'>Veja os Nossos Produtos</h1>
        <div className='flex-center flex-wrap flex__gap-50'>
            <CardProdut 
            imgSrc={camisa}
            imgAlt="Moletom Masculino"
            price="171,45"
            nameProduct="Moletom Masculino"
            />
            <CardProdut 
            imgSrc={bone}
            imgAlt="Boné Americano"
            price="48,80"
            nameProduct="Boné Americano"
            />
            <CardProdut 
            imgSrc={garrafa}
            imgAlt="Garrafa Térmica"
            price="63,10"
            nameProduct="Garrafa Térmica"
            />
        </div>
        <a href='https://mont.ink/raffael-fragoso' target='__blanck' rel='noopener noreferrer'>
            <button className='btn-default'>Veja mais em nossa loja</button>
        </a>
    </section>
  )
}

export default Products
